module.exports = __webpack_public_path__ + "2ffe2f2c0cda540a768a38396de64ae9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-2.png
// module id = 3144
// module chunks = 0